import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const headingVariants = cva(
  "font-display tracking-tight",
  {
    variants: {
      variant: {
        xl: "text-4xl md:text-5xl lg:text-7xl font-bold font-stretch-[125%]",
        lg: "text-3xl md:text-4xl lg:text-5xl font-normal font-stretch-[125%] mb-4",
        md: "text-2xl md:text-3xl font-normal [font-variation-settings:'wdth'_115.4]",
        sm: "text-xl md:text-2xl font-semibold font-stretch-[125%]",
        xs: "text-md font-medium font-mono [font-variation-settings:'wdth'_100] uppercase",
      },
    },
    defaultVariants: {
      variant: "md",
    },
  }
)

export interface HeadingProps
  extends React.HTMLAttributes<HTMLHeadingElement>,
    VariantProps<typeof headingVariants> {
  level?: 1 | 2 | 3 | 4 | 5 | 6
  as?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p" | "span"
}

function Heading({
  className,
  variant = "md",
  level,
  as,
  ...props
}: HeadingProps) {
  // Determine the component to render
  // Priority: as prop > level prop > default to div
  const Component = as || (level ? `h${level}` as const : "div")

  return (
    <Component
      className={cn(headingVariants({ variant, className }))}
      {...props}
    />
  )
}

export { Heading, headingVariants }
